import * as Sentry from '@sentry/react';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import toaster from 'react-hot-toast';
import {
  type ArchiveFirmwareReleasesParams,
  archiveFirmwareReleases,
} from 'api/admin/firmware/firmware';

export const useArchiveFirmwareReleases = ({
  successCallback,
}: {
  successCallback?: () => void;
}) => {
  return useMutation<unknown, AxiosError<{ error: string }>, ArchiveFirmwareReleasesParams>({
    mutationFn: async ({ releaseIds, archived }: ArchiveFirmwareReleasesParams) => {
      return archiveFirmwareReleases({ releaseIds, archived });
    },
    onSuccess: async (_data, { archived }) => {
      successCallback?.();
      toaster(`Successfully ${archived ? 'archived' : 'unarchived'} firmware releases`, {
        icon: '✅',
      });
    },
    onError: (error, { archived }) => {
      Sentry.captureException(error);

      toaster(
        error?.response?.data?.error ??
          `Failed to ${archived ? 'archive' : 'unarchive'} firmware releases`,
        {
          icon: '❌',
        },
      );
    },
  });
};
